import { Platform } from 'react-native';
export const createIosMenu = () => {
  throw new Error('createIosMenu is not implemented on ' + Platform.OS);
};
//# sourceMappingURL=index.js.map